import { ErrorBoundary } from '@rollbar/react';
import { BookingCheckout } from 'booking/components';
import { FatalErrorWithStack } from 'ui-components';

export function IframeCheckout(): React.ReactElement {
  return (
    <ErrorBoundary fallbackUI={FatalErrorWithStack}>
      <BookingCheckout manual={false} hidePassBadge />
    </ErrorBoundary>
  );
}
